import * as ActionType from '../../constants/actionType';
import {SignalRHub} from '../../constants/dataEnum';

const initialState = {
  [SignalRHub.SESSION]: null,
  [SignalRHub.AUTHORING]: null,
  [SignalRHub.STATE]: null,
  [SignalRHub.TRAY]: null,
  [SignalRHub.INSTRUMENT]: null,
  [SignalRHub.USER_MANAGEMENT]: null,
  [SignalRHub.LABWARE_DEFINITION]: null,
  [SignalRHub.PROTOCOL]: null,
  [SignalRHub.PROTOCOL_MANAGEMENT]: null,
  [SignalRHub.SOFTWARE_UPDATER]: null,
  [SignalRHub.BACKUP_AND_RESTORE]: null,
  latestEventReceived: '',
};

export default function signalrStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_SESSION_HUB:
      return {...state, [SignalRHub.SESSION]: action.hub};
    case ActionType.SET_AUTHORING_HUB:
      return {...state, [SignalRHub.AUTHORING]: action.hub};
    case ActionType.SET_STATE_HUB:
      return {...state, [SignalRHub.STATE]: action.hub};
    case ActionType.SET_INSTRUMENT_HUB:
      return {...state, [SignalRHub.INSTRUMENT]: action.hub};
    case ActionType.SET_TRAY_HUB:
      return {...state, [SignalRHub.TRAY]: action.hub};
    case ActionType.SET_USER_MANAGEMENT_HUB:
      return {...state, [SignalRHub.USER_MANAGEMENT]: action.hub};
    case ActionType.SET_LABWARE_DEFINITION_HUB:
      return {...state, [SignalRHub.LABWARE_DEFINITION]: action.hub};
    case ActionType.SET_PROTOCOL_HUB:
      return {...state, [SignalRHub.PROTOCOL]: action.hub};
    case ActionType.SET_PROTOCOL_MANAGEMENT_HUB:
      return {...state, [SignalRHub.PROTOCOL_MANAGEMENT]: action.hub};
    case ActionType.SET_SOFTWARE_UPDATER_HUB:
      return {...state, [SignalRHub.SOFTWARE_UPDATER]: action.hub};
    case ActionType.SET_BACKUP_AND_RESTORE_HUB:
      return {...state, [SignalRHub.BACKUP_AND_RESTORE]: action.hub};
    case ActionType.SET_LATEST_SIGNAL_R_EVENT_RECEIVED:
      return {...state, latestEventReceived: action.event};
    case ActionType.SET_HUB:
      return {...state, [action.hubName]: action.hub};
    default:
      return state;
  }
}
